import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React, { PropsWithChildren } from "react";
import QABreadcrumbsHeader, { Breadcrumb } from "../Layout/QABreadcrumbsHeader";

interface Props {
    className?: string;
    testId?: string;

    // These props are passed to QABreadcrumbsHeader
    title?: string;
    breadcrumbs?: Breadcrumb[];
    description?: string;
}

const useStyles = makeStyles(() => ({
    root: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        maxHeight: "100%"
    }
}));

const SettingsPage: React.FC<PropsWithChildren<Props>> = props => {
    const classes = useStyles();

    return (
        <div
            data-cy={`${props.testId}`}
            className={clsx(classes.root, props.className)}>
            {props.title && (
                <QABreadcrumbsHeader
                    title={props.title}
                    breadcrumbs={props.breadcrumbs}
                    description={props.description}
                    testId={`${props.testId}-QABreadcrumbHeader`}/>

            )}
            {props.children}
        </div>
    );
};

export default SettingsPage;
